import { render, staticRenderFns } from "./AssessmentContainer.vue?vue&type=template&id=7b5ff341&"
import script from "./AssessmentContainer.vue?vue&type=script&lang=js&"
export * from "./AssessmentContainer.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports